import { DEFAULT_REDACTION, redactSensitiveInfo } from '@repo/lib/strings';

/**
 * Network telemetry now ships every request URL, and PDP URLs routinely carry
 * order/tracking tokens and customer identifiers in their query string. None of
 * those param values are worth logging, so every query value is redacted while
 * the keys are kept for debugging. The path is still run through the standard
 * PII redaction in case a token leaked into a path segment.
 */
export const redactUrl = (value: unknown): unknown => {
  if (typeof value !== 'string') {
    return value;
  }

  const queryIndex = value.indexOf('?');
  if (queryIndex === -1) {
    return redactSensitiveInfo(value);
  }

  const path = value.slice(0, queryIndex);
  const afterPath = value.slice(queryIndex + 1);
  const hashIndex = afterPath.indexOf('#');
  const query = hashIndex === -1 ? afterPath : afterPath.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : afterPath.slice(hashIndex);

  const redactedQuery = query
    .split('&')
    .map((pair) => {
      if (!pair) {
        return pair;
      }
      const eq = pair.indexOf('=');
      return eq === -1 ? pair : `${pair.slice(0, eq)}=${DEFAULT_REDACTION}`;
    })
    .join('&');

  return `${redactSensitiveInfo(path)}${redactedQuery ? `?${redactedQuery}` : ''}${hash}`;
};
